import TimeIsDisplay from './TimeIsDisplay'
import TimeIsForm from './TimeIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconTime from 'components/Icons/Time'

export default {
  id: 'time_is',
  label: 'Time is',
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/time-is',
  icon: IconTime,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: TimeIsDisplay,
  form: TimeIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/TimeIs/index.js